// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"92fc1696","71":"8f28ecd9","78":"807e2602","127":"02fee023","209":"d2c810a4","228":"5f34a07b","313":"d2f716d8","362":"1227a66e","691":"807d8bb5","696":"c99b7dba","853":"dc181ae0","980":"31a9a7b3"}[chunkId] + ".chunk.js";
};